import axios from '@/http/axios/index.js'

export default {
    getExpenses(data) {
        return axios.get('hsbc/get-expenses', { params: data })
    },
    getClients() {
        return axios.get('hsbc/get-clients')
    },
    getVendors() {
        return axios.get('hsbc/get-vendors')
    },
    getCompanies() {
        return axios.get('hsbc/get-companies')
    },
    getPeriods() {
        return axios.get('hsbc/get-periods')
    },
    getCompany(id) {
        return axios.get('hsbc/get-company/' + id)
    },
    getClientAccount(payload) {
        return axios.get('hsbc/get-client-account', { params: payload })
    },
    getAccounts(payload) {
        return axios.get('hsbc/get-vendor-accounts', { params: payload })
    },
    generate(data) {
        return axios.post('hsbc/generate', data)
    },



}
